import { useState } from "react";
import { MessageCircle, X, MessageSquareText, Phone } from "lucide-react";

const HELP_PHONE_DISPLAY = "630-624-5127";
const HELP_PHONE_RAW = "+16306245127";

export const HelpWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-[70] flex flex-col items-end gap-3">
      {open && (
        <div
          data-testid="help-widget-panel"
          className="w-72 overflow-hidden rounded-2xl border border-border bg-card shadow-2xl animate-in fade-in slide-in-from-bottom-2 duration-200"
        >
          <div className="flex items-center justify-between bg-primary px-4 py-3">
            <div className="flex items-center gap-2 text-primary-foreground">
              <MessageCircle className="h-4 w-4" />
              <span className="font-heading text-sm font-bold uppercase tracking-tight">Need help?</span>
            </div>
            <button
              onClick={() => setOpen(false)}
              data-testid="help-widget-close"
              className="rounded-md p-1 text-primary-foreground/80 transition-colors hover:bg-black/10 hover:text-primary-foreground"
              aria-label="Close help"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          <div className="space-y-3 p-4">
            <p className="text-sm text-muted-foreground">
              Questions or issues? Text us and we'll get right back to you.
            </p>

            <a
              href={`sms:${HELP_PHONE_RAW}`}
              data-testid="help-widget-text-link"
              className="flex items-center gap-3 rounded-xl border border-border bg-secondary/40 px-3 py-3 transition-colors hover:border-primary/60 hover:bg-secondary/70"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/15 text-primary">
                <MessageSquareText className="h-4 w-4" />
              </span>
              <span className="flex flex-col">
                <span className="text-xs font-mono uppercase tracking-wider text-muted-foreground">Text us</span>
                <span className="text-sm font-semibold text-foreground">{HELP_PHONE_DISPLAY}</span>
              </span>
            </a>

            <a
              href={`tel:${HELP_PHONE_RAW}`}
              data-testid="help-widget-call-link"
              className="flex items-center gap-2 text-xs font-medium text-muted-foreground transition-colors hover:text-primary"
            >
              <Phone className="h-3.5 w-3.5" /> Prefer to call? Tap here
            </a>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="help-widget-button"
        aria-label="Open help"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-xl transition-transform duration-200 hover:scale-105 active:scale-95"
      >
        {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </div>
  );
};
